module.exports = __webpack_public_path__ + "img/dizi2_49f6dbc86.png";